import Main from './Main'
import Lista from './components/LocalizacaoLista'
import Novo from './components/NovaLocalizacao'

export default [
  {
    path: 'localizacao',
    name: 'policiacivil.processo.localizacao',
    component: Main,
    redirect: { name: 'policiacivil.processo.localizacao.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.localizacao.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.localizacao.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.localizacao.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/localizacao/routes.js